import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import Item from './PreviewItem';

class PreviewList extends Component {
  renderTip = () => {
    if (this.props.disableTip) return;
    if (this.props.attachments.length === 0) return;

    return (
      <div className="nudgeTip -success">
        <i className="materialIcon --micro -success">info</i>
        <p>
          {' '}
          Remember: <br />
          To speed up your applications, always upload clear, readable documents
          with complete requirements!
        </p>
      </div>
    );
  };

  onRemove = (attachment, e) => {
    e.preventDefault();
    if (this.props.loading) return;

    let new_attachments = [];
    if (attachment.id) {
      new_attachments = this.props.attachments.map(a => {
        if (a === attachment) {
          return Object.assign({}, attachment, {_destroy: true});
        }
        return a;
      });
    } else {
      new_attachments = this.props.attachments.filter(a => a !== attachment);
    }

    // TODO: update onChange with less params
    this.props.onChange('attachments', new_attachments);
    if(this.props.onRemove) {
      this.props.onRemove();
    }
  };

  activeAttachments = () => {
    if (!this.props.attachments) return [];
    return this.props.attachments.filter(a => !a._destroy);
  };

  renderErrors = () => {
    if (this.props.errors.length === 0) return <Fragment />;

    return (
      <ul className="listText --micro -subtle">
        {this.props.errors.map(item => {
          return (
            <li key={item.file.name}>
              {' '}
              {item.file.name} - {item.error}{' '}
            </li>
          );
        })}
      </ul>
    );
  };

  render() {
    if (this.props.attachments.length === 0 && this.props.errors.length === 0)
      return <Fragment />;

    return (
      <section className="cardSection _addDepth">
        {this.renderErrors()}
        {this.renderTip()}
        <ul className="imageThumbs">
          {this.activeAttachments().map((item, i) => {
            return (
              <Item
                key={i}
                attachment={item}
                onRemove={this.onRemove}
                disableAction={this.props.disableAction}
              />
            );
          })}
        </ul>
      </section>
    );
  }
}

PreviewList.propTypes = {
  errors: PropTypes.array,
  attachments: PropTypes.array,
  disableAction: PropTypes.bool,
  disableTip: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
}

export default PreviewList;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/PreviewList.js